import DEFAULT_PALETTE_LIGHT from '../components/Theme/Palette/default_light'
import DEFAULT_PALETTE_DARK from '../components/Theme/Palette/default_dark'

import PORTAL_PALETTE_LIGHT from '../components/Theme/Palette/portal_light'
import PORTAL_PALETTE_DARK from '../components/Theme/Palette/portal_dark'

import yaml from 'js-yaml'

import CONFIG from '@features/config.json'

export function getEnviron() {
    let environ = 'local'
    const hosts = window.location.host.split('.')

    // default => local
    // https://dppotal.localhost => localhost
    // https://<env>.z6.web.core.windows.net => <env>
    // https://<env>.dpportal.isap.tgscloud.net => <env>
    // https://<env>.multiportalnp.isap.tgscloud.net => multiportal_<env>
    // https://<prefix>.<subdomain>.totalenergies.com => prod
    // https://<env>.dpportal.multiportalnp.iasp.tgscloud.net => multiportalnp_<env>

    if (hosts.length === 2
        && hosts[0] === 'dpportal'
        && hosts[1] === 'localhost') environ = 'localhost'
    else if (hosts.length === 6
        && hosts[1] === 'z6'
        && hosts[2] === 'web'
        && hosts[3] === 'core'
        && hosts[4] === 'windows'
        && hosts[5] === 'net') environ = hosts[0]
    else if (hosts.length === 6
        && hosts[1] === 'dpportal'
        && hosts[2] === 'multiportalnp'
        && (hosts[3] === 'iasp' || hosts[3] === 'iasq' || hosts[3] === 'iasd')
        && hosts[4] === 'tgscloud'
        && hosts[5] === 'net') environ = `multiportalnp_${hosts[0]}`
    else if (hosts.length === 5
        && hosts[1] === 'dpportal'
        && (hosts[2] === 'iasp' || hosts[2] === 'iasq' || hosts[2] === 'iasd')
        && hosts[3] === 'tgscloud'
        && hosts[4] === 'net') environ = hosts[0]
    else if (hosts.length === 5
        && hosts[1] === 'multiportalnp'
        && (hosts[2] === 'iasp' || hosts[2] === 'iasq' || hosts[2] === 'iasd')
        && hosts[3] === 'tgscloud'
        && hosts[4] === 'net') environ = `multiportal_${hosts[0]}`
    else if ((hosts.length === 3 && hosts[1] === 'totalenergies' && hosts[2] === 'com')
    || (hosts.length === 4 && hosts[2] === 'totalenergies' && hosts[3] === 'com')) environ = 'prod'

    window.__CONFIG = {
        environ: environ,
        version: CONFIG.version
    }

    return environ
}

export function srand (seed) {
    if (typeof seed === 'string') {
        const str = seed
        seed = 0xFF
        for (let i = 0; i < str.length; i++)
            seed ^= str.charCodeAt(i)
    }

    return function (max, min) {
        max = max || 1
        min = min || 0
        seed = (seed * 9301 + 49297) % 233280

        return min + (seed / 233280) * (max - min)
    }
}

export function roundD (nbr, decimal) {
    const precision = decimal || 2
    const tmp = Math.pow(10, precision)
    return Math.round(parseFloat(nbr) * tmp) / tmp
}

export function addZeroes(num, len = 2, nan = '-') {
    if (isNaN(num)) return nan
    return Number(num).toFixed(len)
}

export function ucfirst (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
}

export function createId(size = 5) {
    const str = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

    let id = ''
    let now = Date.now()
    srand(now * 1000000)
    for(let i=0; i<size; i++) id += str[Math.floor(Math.random() * str.length)]
    return id
}

export function dateDiff(startDate, endDate) {
    let tmp = endDate - startDate
    const diff = {}

    tmp = Math.floor(tmp / 1000)
    diff.sec = tmp % 60

    tmp = Math.floor((tmp - diff.sec) / 60)
    diff.min = tmp % 60

    tmp = Math.floor((tmp - diff.min) / 60)
    diff.hours = tmp % 24

    tmp = Math.floor((tmp - diff.hours) / 24)
    diff.days = tmp

    return diff
}

export function computeCardTrending(value, value2, id, reversed = []) {
    let res = roundD((value * 100) / parseInt(value2))
    let display = true

    if (res > Number.MAX_VALUE || Number.isNaN(res)) {
        res = 0
        value = 0
        display = false
    }

    let green = 'green'
    let red = 'red'

    if (reversed.indexOf(id) >= 0) {
        green = 'red'
        red = 'green'
    }

    return {
        value: `${(value > 0) ? '+' : ''}${new Intl.NumberFormat('fr-FR', { maximumFractionDigits: (value >= 100 ) ? 0 : 2}).format(res)}%`,
        color: (value > 0) ? green : ((value === 0) ? 'default' : red),
        direction: (value > 0) ? 'up' : ((value === 0) ? 'flat' : 'down'),
        display: display
    }
}

export function computeCardAggregation(
    cardsStr = [],
    cards = [],
    labels = ['', ''],
    values = ['', ''],
    reversed = []
) {
    const aggregation = []

    for (let i = 0; i < cardsStr.length; i++) {
        const item = cardsStr[i]

        let value1 = cards[item.id][values[0]]
        let value2 = cards[item.id][values[1]]
        let value = value1 - value2

        let directionUp = 'up'
        let directionDown = 'down'
        if (reversed.indexOf(item.id) >= 0) {
            directionUp = 'down'
            directionDown = 'up'
        }

        aggregation.push({
            name: item.label,
            id: item.id,
            trending: computeCardTrending(value, value2, item.id, reversed),
            diff: {
                direction: (value > 0) ? directionUp : directionDown,
                value: `${(value > 0) ? '+' : ''}${new Intl.NumberFormat('fr-FR', { maximumFractionDigits: (value >= 100 ) ? 0 : 2}).format(value)}`, trending: (value > 0) ? 'up' : ((value === 0) ? 'flat' : 'down'),
                label1: labels[0],
                value1: `${new Intl.NumberFormat('fr-FR', { maximumFractionDigits: (value1 >= 100 ) ? 0 : 2}).format(value1)}`,
                label2: labels[1],
                value2: `${new Intl.NumberFormat('fr-FR', { maximumFractionDigits: (value2 >= 100 ) ? 0 : 2}).format(value2)}`
            }
        })
    }

    return aggregation
}

export function sortObjectByDateKeys(obj) {
    const sortedKeys = Object.keys(obj).sort((a, b) => new Date(a) - new Date(b))
    const sortedObj = {}

    sortedKeys.forEach(key => { sortedObj[key] = obj[key] })

    return sortedObj
}

export function sortObjectByAlphabetic(obj, reversed = false) {
    const keys = Object.keys(obj)

    keys.sort()
    if (reversed) keys.reverse()

    const newKeys = {}
    keys.forEach(function(key) { newKeys[key] = obj[key] })

    return newKeys
}

export function setDpPageTitle(title, target = '.page-title .field.field--name-title.field--type-string') {
    const elem = document.querySelector(target)
    if (!elem) return
    elem.innerHTML = title
}

export function setDpPageBreadcrumb(items = [], target = '.breadcrumb') {
    const elem = document.querySelector(target)
    if (!elem) return

    let elems = ''
    for (let i = 0; i < items.length; i++) {
        if (items[i].path) {
            elems = `${elems}
                <li class="breadcrumb-item">
                    <a href="${items[i].path}">${items[i].label}</a>
                </li>
            `
        } else {
            elems = `${elems}
                <li class="breadcrumb-item">
                    ${items[i].label}
                </li>
            `
        }
    }

    elem.innerHTML = elems
}

export function computeGraphTicks(len) {
    const ticks = []

    if (len <= 10) {
        for (let i = 0; i <= len; i++) ticks.push(i)
    } else {
        let step = 1
        let thresholds = [10, 50, 100, 500]
        for (let t = 0; t <= thresholds.length; t++) {
            if (len > thresholds[t])
                step = thresholds[t]
        }

        for (let i = 0; i < len; i += step) ticks.push(i)
    }

    return ticks
}

export function getLoadedPalette()
{
    const DEFAULT_MODE = 'light'
    const DEFAULT_THEME = 'default'

    const SELECTED_MODE = localStorage.getItem('theme.mode') ?? DEFAULT_MODE
    const SELECTED_THEME = localStorage.getItem('theme.theme') ?? DEFAULT_THEME

    const LOADED = {
        default: {
            light: DEFAULT_PALETTE_LIGHT,
            dark: DEFAULT_PALETTE_DARK
        },
        portal: {
            light: PORTAL_PALETTE_LIGHT,
            dark: PORTAL_PALETTE_DARK
        }
    }

    return LOADED[SELECTED_THEME][SELECTED_MODE]
}

export function scrollToTop()
{
    window.scrollTo({top: 0})
    setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }) }, 10)
}

export function getPath(position = -1, segType = 'hash', pathType = 'path') {
    let path

    if (segType === 'hash') {
        path = window.location.hash
        let segs = path.split('?')

        if (pathType === 'path') {
            path = segs[0].split('/')
            path.shift()
            return (position > -1) ? path[position] : path;
        } else if (pathType === 'search' && segs[1]) {
            path = segs[1].split('&')

            let res = {}
            for (let i = 0;  i < path.length; i++) {
                let search = path[i].split('=')
                res = {...res, [search[0]]: search[1]}
            }

            if (position !== 0 && res[position]) return res[position]
            else if (position !== 0 && !res[position]) return null
            else return res
        }
    } else if (segType === 'path') {
        path = window.location.pathname.split('/')
        path.shift()
        return (position > -1) ? path[position] : path;
    } else if (segType === 'search') {
        path = window.location.search
        let segs = path.split('?')

        if (!segs[1]) return null
        path = segs[1].split('&')

        let res = {}
        for (let i = 0;  i < path.length; i++) {
            let search = path[i].split('=')
            res = {...res, [search[0]]: search[1]}
        }

        if (position !== 0 && res[position]) return res[position]
        else if (position !== 0 && !res[position]) return null
        else return res
    }

    return null
}

export function putPath() {}

export function tplRender(tpl, data, delimiterStart = '{{', delimiterEnd = '}}') {
    let result = tpl;

    for (const [key, value] of Object.entries(data)) {
        const placeholder = delimiterStart + key + delimiterEnd
        const regex = new RegExp(placeholder.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g')
        result = result.replace(regex, value)
    }

    return result
}

export function jsonToYaml(jsonObject, options = {}) {
    return yaml.dump(jsonObject, {
        indent: 2,
        lineWidth: -1,
        noRefs: true,
        ...options
    })
}